"use client";

import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {ButtonSimple} from "@/shared/ui/buttons";

import "./styles/image-preview.scss";

export interface ImagePreviewProps {
    src: string;
    alt: string;
    showButton?: boolean;
    buttonText?: string;
    onButtonClick?: () => void;
    onImageClick?: () => void;
    className?: string;
    priority?: boolean;
    width?: number;
    height?: number;
}

/**
 * Image preview component - displays main image with optional button
 */
export function ImagePreview({
    src,
    alt,
    showButton = false,
    buttonText = "View Photos & 3D Tour",
    onButtonClick,
    onImageClick,
    className = "",
    priority = false,
    width,
    height,
}: ImagePreviewProps): JSX.Element {
    const mediaSize = Number.isFinite(width) && Number.isFinite(height) ? {width, height} : {fill: true};
    return (
        <div className={`image-preview ${className}`}>
            <div
                className={`image-preview__wrapper ${onImageClick ? "image-preview__wrapper--clickable" : ""}`}
                role={onImageClick ? "button" : undefined}
                tabIndex={onImageClick ? 0 : undefined}
                onClick={onImageClick}
                onKeyDown={onImageClick ? (e) => e.key === "Enter" && onImageClick() : undefined}
            >
                <SmartImage
                    src={src}
                    alt={alt}
                    {...mediaSize}
                    fetchPriority="high"
                    className="image-preview__image"
                    priority={priority}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />

                {showButton && (
                    <div className="image-preview__overlay">
                        <ButtonSimple
                            as="button"
                            variant="primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                onButtonClick?.();
                            }}
                            className="image-preview__button"
                        >
                            {buttonText}
                        </ButtonSimple>
                    </div>
                )}
            </div>
        </div>
    );
}
